<script setup>
defineProps({
  itemParaEditar: { type: Object, default: null }
})
defineEmits(['itemAtualizado', 'cancelar', 'show-notification'])
</script>
<template>
  <div class="p-5 text-center">
    <i class="bi bi-shield-check fs-1 text-danger mb-3 d-block"></i>
    <h4 class="text-body-emphasis">Documentação Aduaneira</h4>
    <p class="text-body-secondary">Módulo em desenvolvimento.</p>
  </div>
</template>
